export { DadosGerenciaveis } from './DadosGerenciaveis'
